import React, { useState, useEffect } from "react";
import { SingleDropdownListWithoutSearch } from "../../../Common/Components/SingleDropdownListWithoutSearch";
import moment from "moment";

interface DateRangeProps {
  onAccountingPeriodChange: (accountingPeriod: string|null) => void;
}

const AccountingPeriod: React.FC<DateRangeProps> = ({ onAccountingPeriodChange }) => {
  const [accountingPeriod, setAccountingPeriod] = useState<string>("");
  const [accountingPeriodList, setAccountingPeriodList] = useState<any[]>([]);

  useEffect(() => {
  const periodList: any[] = [];
  let currentDate = moment().startOf("month");

  for (let i = 0; i < 60; i++) {
    periodList.push({
      id: currentDate.format("MM/DD/YYYY"), 
      name: currentDate.format("MM/YYYY"),
    });

    currentDate = currentDate.subtract(1, "month");
  }


  setAccountingPeriod(moment().startOf("month").format("MM/DD/YYYY"));
  onAccountingPeriodChange(moment().startOf("month").format("MM/DD/YYYY")); 
  setAccountingPeriodList(periodList);
}, []);


  // useEffect(() => {
  //   const periodList: any= [];
  //   let currentDate = new Date();
  //   currentDate.setDate(1);
  //   const today = moment(currentDate).format("MM/DD/YYYY");

  //   for (let i = 0; i < 10; i++) {
  //     periodList.push({
  //       id: moment(currentDate).format("MM/DD/YYYY"),
  //       name: moment(currentDate).format("MM/YYYY"),
  //     });
  //     currentDate.setMonth(currentDate.getMonth() + 1);
  //   }
  //   setAccountingPeriod(today);
  //   setAccountingPeriodList(periodList);
  // }, []);

  const handleSelectedItem = (id: string) => {
    setAccountingPeriod(id); 
    onAccountingPeriodChange(id); 
  };

  return (
    <>
      <label className="font-semibold">Accounting Period</label>
      <div className="w-50">
        {accountingPeriodList.length > 0 && (
          <SingleDropdownListWithoutSearch
            tabIndex={1} 
            itemList={accountingPeriodList}
            handleSelectedItem={handleSelectedItem} 
            defaultItem={accountingPeriod.split('/').slice(0, 1).concat(accountingPeriod.split('/')[2]).join('/')}
            defaultName={accountingPeriod.split('/').slice(0, 1).concat(accountingPeriod.split('/')[2]).join('/')}         
            controlID="1"
            disabled={false}
            id="ddlAccounting"
          />
        )}
      </div>
    </>
  );
};

export default AccountingPeriod;
